import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";

const ActiveStatusSwitch = ({ record, handleActiveStatus }) => {
  
  const now = new Date();
  const validFrom = record.valid_from ? new Date(record.valid_from) : null;
  const validTo = record.valid_to ? new Date(record.valid_to) : null;

  let isToggleDisabled = false;
  let reason = "";

  if (validFrom && validTo) {
    if (now < validFrom) {
      isToggleDisabled = true;
      reason = "Notification validity has not started yet.";
    } else if (now > validTo) {
      isToggleDisabled = true;
      reason = "Notification validity period has expired.";
    }
  } else if (validFrom && !validTo) {
    if (now < validFrom) {
      isToggleDisabled = true;
      reason = "Notification validity has not started yet.";
    }
  } else if (!validFrom && validTo) {
    if (now > validTo) {
      isToggleDisabled = true;
      reason = "Notification validity period has expired.";
    }
  }

  const handleToggle = () => {
    if (isToggleDisabled) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: reason,
      });
      return;
    }

    handleActiveStatus(record.id, record.title,record);
  };

  return (
    <div
      className="d-flex align-items-center gap-2"
      key={`switch-${record.id}`}
    >
      {isToggleDisabled ? (
        <Tooltip
          title={reason}
          arrow
          placement="top"
          componentsProps={{
            tooltip: {
              sx: {
                fontSize: "0.95rem",
                padding: "8px 12px",
                borderRadius: "8px",
              },
            },
          }}
        >
          <span>
            <div className="custom-control custom-switch">
              <input
                type="checkbox"
                checked={!!record.isActive}
                disabled={isToggleDisabled}
                onChange={handleToggle}
                className="custom-control-input"
                id={`customSwitch-${record.id}`}
              />
              <label
                className="custom-control-label"
                htmlFor={`customSwitch-${record.id}`}
              ></label>
            </div>
          </span>
        </Tooltip>
      ) : (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            checked={!!record.isActive}
            disabled={isToggleDisabled}
            onChange={handleToggle}
            className="custom-control-input"
            id={`customSwitch-${record.id}`}
          />
          <label
            className="custom-control-label"
            htmlFor={`customSwitch-${record.id}`}
          ></label>
        </div>
      )}
    </div>
  );
};

export default ActiveStatusSwitch;
